import React from 'react';

import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import classes from 'components/common/ErrorPages/ErrorPages.module.scss';

import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';

export const PageNotFound = () => {
    return (
        <div className={classes.message}>
            <div className={classes.description}>
                <h1>Sorry, Page/Item Not Found</h1>
            </div>
            <div>
                <Link to="/">Go to homepage</Link> or{' '}
                <Link to={AppRoutes.buildPath(AppRoutes.DASHBOARD_PROJECT_PATH, projectConfig.programLibrary.link)}>
                    Program Library
                </Link>
            </div>
        </div>
    );
};
